import { render } from "./LanguageSelect.vue?vue&type=template&id=43fb60ed&scoped=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"

import "./LanguageSelect.vue?vue&type=style&index=0&id=43fb60ed&lang=less&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fb60ed"]])

export default __exports__